// src/components/organisms/landing/sticky-cta/sticky-cta.tsx
"use client";

import { useEffect, useState } from "react";
import { CtaButton } from "@/components/atoms/landing/cta-button";

export function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // On phones the cookie banner spans the full width at the bottom and marks
  // <html> with data-cookie-banner-open while it is open; the bar steps aside
  // until then (the header and hero carry the same two links).
  return (
    <div
      inert={!visible}
      className={`pointer-events-none fixed inset-x-0 bottom-4 z-30 max-sm:[html[data-cookie-banner-open]_&]:hidden flex justify-center px-4 transition-opacity duration-300 motion-reduce:transition-none ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        className={`pointer-events-auto flex w-full max-w-3xl items-center justify-between gap-4 rounded-full border border-brand-border bg-white py-2 pl-4 pr-20 shadow-lg sm:pl-6 lg:pr-6 ${
          visible ? "translate-y-0" : "translate-y-4"
        } transition-transform duration-300 motion-reduce:transition-none`}
      >
        <p className="hidden min-w-0 truncate text-sm font-medium text-brand-ink sm:block">
          Ready to integrate payments?
        </p>
        <div className="flex items-center gap-2">
          <CtaButton
            href="/docs"
            variant="ghost"
            size="md"
            trailingIcon={false}
            ctaPlacement="sticky_docs"
          >
            Docs
          </CtaButton>
          <CtaButton href="/sign-up" size="md" ctaPlacement="sticky_primary">
            Get started
          </CtaButton>
        </div>
      </div>
    </div>
  );
}
